import { Component, OnInit ,ViewChild} from '@angular/core';
import { NgForm } from "@angular/forms";
import { DateAdapter } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from "@angular/common";
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { ChequereceiptService } from "../shared/chequereceipt.service";

@Component({
  selector: 'app-chequereceipt',
  templateUrl: './chequereceipt.component.html',
  styleUrls: ['./chequereceipt.component.css']
})
export class ChequereceiptComponent implements OnInit {

  AddButtonText: string = "Add";
  ErrorText: string ;
  ParentChequereceiptNo: number;
  ChequeReceiptTypeList:[''];
  AgentList:[''];
  BankingTypeList:[''];

  constructor(public chequeReceiptService: ChequereceiptService, private dateAdapter: DateAdapter<Date>,
    private router: Router, private activatedRoute: ActivatedRoute,) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(param => {
      this.ParentChequereceiptNo = + param['Id'];  //EnquiryNo
    });

    this.resetForm();
    this.GetChequeByChequeNo();
    this.GetChequeReceiptTypeList();
    this.GetBankingTypeList();
    this.GetAgentList();
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.chequeReceiptService.selectedChequereceipt = {

      Id:null,
      ChequeDate  :new Date(),  //.toString("yyyy/MM/dd"),
      CustomerName:null,
      ReceiptType :0,
      ChequeNumber :null,
      BankDetails :null,
      BankBranch :null,
      Amount :0 , 
      TypeId :0 ,
      AgentName:null,
      IsActive :1 ,
      Flag :1,
  }
}

  public onSubmit(form: NgForm) {
    console.log("On submit");

    this.chequeReceiptService.IUDChequeReceipt(form.value)
      .subscribe(data => {
        this.resetForm(form);
        this.router.navigate(['/chequereceiptlist']);
      })
  }

  GetChequeByChequeNo() {

    if (!Number.isNaN(this.ParentChequereceiptNo)) {
      this.chequeReceiptService.selectedChequereceipt.Id = this.ParentChequereceiptNo;
      this.chequeReceiptService.FetchChequeReceiptByReceiptNo(this.chequeReceiptService.selectedChequereceipt).subscribe(data => {

        this.chequeReceiptService.selectedChequereceipt = data;
        this.chequeReceiptService.selectedChequereceipt.Id=+data.Id;
        this.chequeReceiptService.selectedChequereceipt.Flag = 2;
      })
    }
  }

  GetChequeReceiptTypeList(){       
    this.chequeReceiptService.GetChequeReceiptTypeList().subscribe(data => {
      this.ChequeReceiptTypeList =data;
    })
  }
  
  GetBankingTypeList() {
    this.chequeReceiptService.GetBankingTypeList().subscribe(data => {
      this.BankingTypeList =data;
    })
  }

  GetAgentList(){
    this.chequeReceiptService.GetAgentList().subscribe(data => {
      this.AgentList = data;
    })
  }


}
